import React, { useState, useEffect } from 'react';
import './ZoomControl.css';

const HINT_STORAGE_KEY = 'hasSeenZoomHint';

const ZoomControl: React.FC = () => {
  const [showHint, setShowHint] = useState(false);
  const [hintFading, setHintFading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  useEffect(() => {
    const hasSeenHint = localStorage.getItem(HINT_STORAGE_KEY);
    
    if (!hasSeenHint) {
      setShowHint(true);
      localStorage.setItem(HINT_STORAGE_KEY, 'true');

      const fadeTimer = setTimeout(() => {
        setHintFading(true);
      }, 4000);

      const hideTimer = setTimeout(() => {
        setShowHint(false);
        setHintFading(false);
      }, 5000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, []);

  const handleClick = () => {
    setShowPopup(!showPopup);
    setShowHint(false);
  };

  return (
    <div className="zoom-control">
      {showHint && !showPopup && (
        <div className={`zoom-control__hint ${hintFading ? 'zoom-control__hint--fading' : ''}`}>
          Resize for better view
          <div className="zoom-control__hint-arrow" />
        </div>
      )}
      {showPopup && (
        <>
          <div className="zoom-control__overlay" onClick={() => setShowPopup(false)} />
          <div className="zoom-control__popup">
            <div className="zoom-control__popup-header">
              Resize browser zoom to 90% for optimal view
            </div>
            <img 
              src="/assets/preffered_zoom.png" 
              alt="Browser zoom settings" 
              className="zoom-control__popup-image"
            />
            <div className="zoom-control__popup-shortcut">
              Press <kbd>{isMac ? '⌘' : 'Ctrl'}</kbd> + <kbd>-</kbd> to zoom out
            </div>
            <div className="zoom-control__hint-arrow" />
          </div>
        </>
      )}
      <button
        type="button"
        className={`zoom-control__button ${showPopup ? 'zoom-control__button--active' : ''}`}
        onClick={handleClick}
        title="Zoom instructions"
      >
        <svg 
          className="zoom-control__icon" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
          <line x1="8" y1="11" x2="14" y2="11" />
        </svg>
      </button>
    </div>
  );
};

export default ZoomControl;
